<app-g0-guest-menu-desktop [target]="[null]"></app-g0-guest-menu-desktop>
<app-guest-gallery-detail [photos]="photos"></app-guest-gallery-detail>
